import { redirect } from "react-router-dom";

export const protectedRouteLoader = () => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    return redirect("/login");
  }
  return null;
};
